import { useContext, useMemo } from 'react';
import { CustomFormContext } from '../../customFormContextProvider';

const mergeProductArrays = (editorialProducts, chProducts) => {
  const findMatchingItem = (arr, titleUrl) => {
    return arr.find((item) => item.titleUrl === titleUrl);
  };

  return editorialProducts.map((productItem) => {
    const matchingChProductItem = findMatchingItem(chProducts, productItem.titleUrl);

    // If matching chProduct item is found
    if (matchingChProductItem) {
      productItem.title = matchingChProductItem.title;

      // If product item series is null, take it from chProduct
      if (!productItem.series) {
        productItem.series = matchingChProductItem.series;
      } else {
        // Iterate through series in product item
        productItem.series = productItem.series.map((productSeries) => {
          const matchingChProductSeries = findMatchingItem(matchingChProductItem.series, productSeries.titleUrl);

          // If matching series in chProduct is found
          if (matchingChProductSeries) {
            productSeries.title = matchingChProductSeries.title;

            // If product series models is null, take models from chProduct
            if (!productSeries.models) {
              productSeries.models = matchingChProductSeries.models;
            } else {
              // Iterate through models in original series
              productSeries.models = productSeries.models.map((productModel) => {
                const matchingChProductModel = findMatchingItem(matchingChProductSeries.models, productModel.titleUrl);

                // If matching model in chProduct is found
                if (matchingChProductModel) {
                  productModel.title = matchingChProductModel.title;
                  productModel.id = matchingChProductModel.id;
                }

                return productModel;
              });
            }
          }

          return productSeries;
        });
      }
    }

    return productItem;
  });
};

const useCreateProductSelectorList = (chProductList, editorProductList) => {
  const customFormContext = useContext(CustomFormContext);
  const isEnablePreSelection = customFormContext?.params?.enablePreselection === '1';

  const productList = useMemo(() => {
    if (isEnablePreSelection && editorProductList && editorProductList.length && chProductList?.length) {
      return mergeProductArrays(editorProductList, chProductList);
    } else {
      return chProductList;
    }
  }, [chProductList, editorProductList]);
  return productList;
};

export default useCreateProductSelectorList;
